// extracted by css-extract-rspack-plugin
export default {"feedbackModalNegativeSection":"feedback-modal-negative-section--pDiO7AB4jewRErCY","feedbackModalContent":"feedback-modal-content--WBxH5CMgQgABWDc6"};